var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 31.968,
    viewBox: "0 0 88 31.968",
    width: 88,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0280bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.014 4.43h-2.014v25.186h14.057v-2.016h-12.043z",
    transform: "translate(0 -3.752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.539.662h2.014v25.248h-2.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.829 26.368-17.813-22.038h-2.016v25.248h2.014v-22.042l17.815 22.042h2.016v-25.248h-2.016z",
    transform: "translate(-181.267 -3.668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.246 23.188a13.323 13.323 0 0 0 2.921-3.671 13.153 13.153 0 0 0 1.583-6.271 13.261 13.261 0 0 0 -13.239-13.246h-.011a13.252 13.252 0 0 0 -5.506 25.29 13.068 13.068 0 0 0 3.44 1.037l-2.534 1.073-.21.089-.055.023-3.335 1.412.789 1.854 3.347-1.422a7.34 7.34 0 0 1 2.92-.459h.141a9.29 9.29 0 0 1 4.742 1.6 8.515 8.515 0 0 0 4.185 1.473 6.8 6.8 0 0 0 5.095-2.089l-1.548-1.291a4.843 4.843 0 0 1 -3.547 1.364 6.823 6.823 0 0 1 -3.191-1.21 14.32 14.32 0 0 0 -3.584-1.592l4.176-1.788a13.63 13.63 0 0 0 3.421-2.176zm-8.746 1.285h-.326a11.127 11.127 0 0 1 -5.185-1.445 11.206 11.206 0 1 1 5.511 1.445z",
    transform: "translate(-340.75)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.434c79b76da7b2b0d87b26012cc5defb.svg";
export { ForwardRef as ReactComponent };